import type { IAiLimitationsResponse } from "@/shared/types/ai.types";
import { apiClient } from "@lib/axios";
import type {
  GenerateImageRequest,
  GenerateImageResponse,
  MediaPromptSuggestionsRequest,
  MediaPromptSuggestionsResponse,
} from "./types";

const path = (path: string) => `/ai${path}`;

export const aiApi = {
  generateImage: (data: GenerateImageRequest) => {
    return apiClient.post<GenerateImageResponse>(path("/image"), data);
  },

  getMediaPromptSuggestions: (data: MediaPromptSuggestionsRequest) => {
    return apiClient.post<MediaPromptSuggestionsResponse>(
      path("/media-prompt-suggestions"),
      data,
    );
  },

  getLimitations: (params?: { type?: string }) => {
    return apiClient.get<IAiLimitationsResponse>(path("/limitations"), {
      params,
    });
  },
};
